<template>
  <div :class="$style.footer">
    <div :class="$style.footerCell" :style="{ width: '55%' }">
      <InputNumber
        v-model="probability"
        placeholder="Enter a probability in %"
        :class="[$style.probabilityInput, 'probability-input']"
        :min="0"
        :max="100"
      />
    </div>
    <div :class="$style.footerCell" :style="{ width: '45%' }">
      <div :style="{ width: '100%' }" @click="toggleOverlayPanel">
        <RewardsInput :reward-items="rewardItems" />
      </div>
      <Popover ref="overlayPanel">
        <ItemsBundlesList :reward-items="rewardItems" :show-confirmation="false" @save="handleItemsSave" />
      </Popover>
    </div>
    <div :class="$style.footerCell" :style="{ width: '10%' }">
      <Button icon="pi pi-times" severity="secondary" outlined :class="$style.button" @click="resetForm" />
      <Button icon="pi pi-check" :disabled="!shouldEnableAddButton" :class="$style.button" @click="addReward" />
    </div>
  </div>
</template>

<script setup lang="ts">
import Button from "primevue/button";
import InputNumber from "primevue/inputnumber";
import Popover from "primevue/popover";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";

import ItemsBundlesList from "@/modules/ItemsBundles";
import { FormattedItem } from "@/modules/Rewards/types";
import useRewards from "../../../Rewards/hooks/useRewards";
import RewardsInput from "../components/RewardsInput.vue";

const emit = defineEmits(["add-reward", "reset-form"]);

const route = useRoute();
const gameId = ref<string>(route.params.gameId as string);
const versionId = ref<string>(route.params.versionId as string);

const overlayPanel = ref<InstanceType<typeof Popover> | null>(null);
const rewardItems = ref<FormattedItem[]>([]);
const probability = ref<number>(0);

const shouldEnableAddButton = computed(() => rewardItems.value.length > 0);

const { fetchRewards } = useRewards(gameId.value, versionId.value);

const toggleOverlayPanel = (event: MouseEvent) => {
  overlayPanel.value?.toggle(event);
};

const handleItemsSave = (items: FormattedItem[]) => {
  rewardItems.value = items;
  overlayPanel.value?.hide();
};

const resetForm = () => {
  rewardItems.value = [];
  probability.value = 0;
};

const addReward = () => {
  const input = {
    probabilityPercentage: probability.value,
    items: rewardItems.value.map((item) => ({
      itemId: item.selectedItem?.id || "",
      quantity: item.quantity,
    })),
  };

  emit("add-reward", input);
  resetForm();
};

fetchRewards();
</script>

<style scoped>
:deep(.probability-input .p-inputtext) {
  font-size: 12px;
}
</style>

<style module lang="scss">
.probabilityInput {
  width: 100%;
  font-size: 12px;
  height: 32px;

  &::placeholder {
    font-size: 12px;
  }
}

.footer {
  display: flex;
  width: 100%;
}

.footerCell {
  display: flex;
  align-items: center;
  padding: 0.5rem;
}

.button {
  padding: 0.45rem 0;

  &:first-child {
    margin-right: 0.5rem;
  }
}
</style>
